import React from "react";

// Helper function to get the image URL
const getImageUrl = (imageUrl) => {
  if (imageUrl.startsWith("Images\\")) {
    return `https://app.andosa.org/images/${imageUrl
      .replace("Images\\", "")
      .replace(/\\/g, "/")}`;
  }
  return imageUrl;
};

const ProductCard = ({ product, onClick }) => {
  return (
    <div
      className="card"
      onClick={onClick}
      style={{ cursor: "pointer", fontFamily: '"Baloo Bhaijaan 2"' }}
    >
      <img
        src={getImageUrl(product.image)}
        alt={product.name}
        className="card-img-top"
        width={500}
        height={300}
        style={{ objectFit: "cover" }}
      />
      <div className="card-body">
        <h5 className="card-title">{product.name}</h5>
        <p className="card-text">${product.price}</p>
      </div>
    </div>
  );
};

export default ProductCard;
